var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipCustomerDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vipGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#331642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5652B0"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "goldPattern",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1,
    fill: "#D4AF37"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#vipGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#goldPattern)",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 770,
    height: 170,
    rx: 5,
    fill: "none",
    stroke: "#D4AF37",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30 0 L-15 -20 L0 0 L15 -20 L30 0 L20 10 L-20 10 Z",
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: -25,
    r: 5,
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -25,
    r: 5,
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -25,
    r: 5,
    fill: "#D4AF37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(730, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30 0 L-15 -20 L0 0 L15 -20 L30 0 L20 10 L-20 10 Z",
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: -25,
    r: 5,
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -25,
    r: 5,
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -25,
    r: 5,
    fill: "#D4AF37"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 60)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "#D4AF37"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 25,
    fill: "#2F233C"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 5,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#D4AF37",
    textAnchor: "middle"
  }, "VIP"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 60)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,5 7,6 3.5,10 4,15 0,13 -4,15 -3.5,10 -7,6 -2,5",
    fill: "#D4AF37",
    transform: "scale(2)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 60)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,5 7,6 3.5,10 4,15 0,13 -4,15 -3.5,10 -7,6 -2,5",
    fill: "#D4AF37",
    transform: "scale(2)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 140)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,5 7,6 3.5,10 4,15 0,13 -4,15 -3.5,10 -7,6 -2,5",
    fill: "#D4AF37",
    transform: "scale(1.5)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 140)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,5 7,6 3.5,10 4,15 0,13 -4,15 -3.5,10 -7,6 -2,5",
    fill: "#D4AF37",
    transform: "scale(1.5)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 110,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#D4AF37",
    textAnchor: "middle"
  }, "VIP CUSTOMER DISCOUNT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    fill: "#D4AF37",
    textAnchor: "middle"
  }, "25% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 175,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "Exclusive offer for our most valued customers")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipCustomerDiscount);
export default __webpack_public_path__ + "static/media/vip_customer_discount.4d4a2b868e794a815cab484b903c9a16.svg";
export { ForwardRef as ReactComponent };